import { render, staticRenderFns } from "./TransferIntoInland.vue?vue&type=template&id=a4cca5b4&scoped=true&"
import script from "./TransferIntoInland.vue?vue&type=script&lang=ts&"
export * from "./TransferIntoInland.vue?vue&type=script&lang=ts&"
import style0 from "./TransferIntoInland.vue?vue&type=style&index=0&id=a4cca5b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cca5b4",
  null
  
)

export default component.exports